var _defs, _rect, _circle, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeZoom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-2{fill:#fff;}.cls-3{fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "home_zoom") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-25",
    className: "cls-1",
    x: 16.95,
    y: 12.95,
    width: 4,
    height: 12,
    transform: "translate(-7.85 18.95) rotate(-45)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    className: "cls-2",
    cx: 10.5,
    cy: 10.5,
    r: 9.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.5,21A10.5,10.5,0,1,1,21,10.5,10.51,10.51,0,0,1,10.5,21Zm0-19A8.5,8.5,0,1,0,19,10.5,8.51,8.51,0,0,0,10.5,2Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,16H5V7H16ZM7,14h7V9H7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-27",
    className: "cls-3",
    points: "9 11 12 11 12 15 9 15 9 11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "7 7 14 7 14 8 7 8 7 7"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-28",
    className: "cls-3",
    points: "10.52 3 16 7 5 7 10.52 3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeZoom);
export default __webpack_public_path__ + "static/media/home_zoom.3c33387b31503b3b278dfa7de3f86059.svg";
export { ForwardRef as ReactComponent };